import { ApiFactory } from 'apiFactory'

export const getCurrentIPAddress = async () => {
  const { tosApi } = ApiFactory(localStorage.getItem('eltoro_token'))

  const res = await tosApi?.advertisingPlatformServiceGetUserIPAddress()

  return res?.ipAddress
}
